import { Pipe, PipeTransform } from '@angular/core';
import { HedgeQuote } from '@approot/services';
import { clone } from '@approot/utilities';

@Pipe({
  name: 'sortHedgeQuotes'
})
export class SortHedgeQuotesPipe implements PipeTransform {
  public transform(quotes: HedgeQuote[], _args?: any): HedgeQuote[] {
    if (!quotes) {
      return [];
    }
    if (quotes.some(quote => quote.hedgeDeliveryDate == null)) {
      return quotes;
    }
    return clone(quotes).sort((a, b) => {
      // Types confused, so assume both are strings (probably) or both are numbers
      if (
        typeof a.hedgeDeliveryDate === 'string' &&
        typeof b.hedgeDeliveryDate === 'string'
      ) {
        return a.hedgeDeliveryDate.localeCompare(b.hedgeDeliveryDate);
      }
      if (
        typeof a.hedgeDeliveryDate === 'number' &&
        typeof b.hedgeDeliveryDate === 'number'
      ) {
        return a.hedgeDeliveryDate - b.hedgeDeliveryDate;
      }
      return 0;
    });
  }
}
